import React from "react";
import {
  Button,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  // NavLink,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem
} from "reactstrap";
import { NavLink } from "react-router-dom";

class NnSongMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <UncontrolledDropdown>
        <DropdownToggle nav caret className="btn btn-primary">
          Select a Song
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem>
            <NavLink to="/song/ode-to-joy">Ode to Joy</NavLink>
          </DropdownItem>
          <DropdownItem>
            <NavLink to="/song/twinkle">Twinkle Twinkle</NavLink>
          </DropdownItem>
          <DropdownItem>
            <NavLink to="/song/star-wars">Star Wars theme</NavLink>
          </DropdownItem>
          {/* <DropdownItem header>Tests</DropdownItem>
          <DropdownItem>Test 1</DropdownItem>
          <DropdownItem>Test 2</DropdownItem> */}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }
}

export default NnSongMenu;



// WEBPACK FOOTER //
// ./src/NnSongMenu.js